import React, { useState } from 'react';
import { Modal } from 'reactstrap';

const WarningDialog2 = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Modal
      centered
      isOpen={isOpen}
      style={{
        width: '200px',
        margin: 'auto'
      }}
    >
      <div className='modal-image-section'>
        <p
          style={{
            fontWeight: 'bold',
            padding: '1rem',
            textAlign: 'center',
            fontSize: '.8rem',
            lineHeight: '1.2'
          }}
        >
          *After you paid, you must come back here to submit the Ref/UTR No.(12
          digits) . then your money is credited to your account.
        </p>
        <img src='/images/utr_example.png' alt='warning' className='img1' />
        <img
          src='/images/close.png'
          alt='close'
          className='img2'
          onClick={() => setIsOpen((prev) => !prev)}
        />
      </div>
    </Modal>
  );
};

export default WarningDialog2;
